import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Layout from "./Components/Layout";
import Login from "./Components/Login";
import Dashboard from "./Pages/Dashboard";
import ComposeMessage from "./Components/ComposeMessage";
import ManageTemplates from "./Components/manage_templates/ManageTemplates";
import UseMetaTemplates from "./Components/UseMetaTemplates";
import CreateTemplate from "./Components/manage_templates/CreateTemplate";
import Broadcastlogo from "./Components/Reports/Broadcastlogo";
import ApiLogoui from "./Components/Reports/ApiLogoui";
import ScheduleLogoui from "./Components/Reports/ScheduleLogsUI";
import WhatsAppCampaignTable from "./Components/WhatsAppCampaignTable";
import Billing from "./Components/Billing/Billing";
import FlowPage from "./Components/Flow/FlowPage";
import Contacts from "./Components/Contacts/Contacts";
import Historylive from "./Components/Chat/Historylive";
import ProfilePage from "./Components/Profile/profile";
import { SnackbarProvider } from "./DynamicComponents/SnackbarContext";
import ManageGroups from "./Components/Contacts/ManageGroups";
import FlowChart from "./Components/Flow/FlowChart";
import SupportPage from "./Components/Setttings/support";
import LiveChat from "./Components/Chat/LiveChat";

// ✅ Import the ScrollToTop component
import ScrollToTop from "./DynamicComponents/ScrollToTop";

function App() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
  }, [darkMode]);

  return (
    <SnackbarProvider>
      <Router>
        {/* ✅ Add here so it runs on every route change */}
        <ScrollToTop />

        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login darkMode={darkMode} />} />

          {/* Protected routes inside Layout */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode}>
                  <Routes>
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/dashboard" element={<Dashboard darkMode={darkMode} />} />
                    <Route path="/compose-message" element={<ComposeMessage />} />
                    <Route path="/templates" element={<ManageTemplates />} />
                    <Route path="/use-templates" element={<UseMetaTemplates />} />
                    <Route path="/allcontacts" element={<Contacts />} />
                    <Route path="/manage-groups" element={<ManageGroups />} />
                    <Route path="/create-template" element={<CreateTemplate />} />
                    <Route path="/broadcast-logs" element={<Broadcastlogo />} />
                    <Route path="/Reports" element={<ApiLogoui />} />
                    <Route path="/schedule-logs" element={<ScheduleLogoui />} />
                    <Route path="/WhatsAppCampaignTable/:campaignName" element={<WhatsAppCampaignTable />} />
                    <Route path="/flow" element={<FlowPage />} />
                    <Route path="/flow-chart/:id" element={<FlowChart />} />
                    <Route path="/billing" element={<Billing />} />
                    <Route path="/history" element={<Historylive />} />
                    <Route path="/livechat" element={<LiveChat />} />
                    <Route path="/support" element={<SupportPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </SnackbarProvider>
  );
}

// ✅ Protect routes if token is missing
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default App;
